import { useRef } from "react";

const beforeAfterCases = Array.from({ length: 9 }, (_, index) => {
    const caseNumber = index + 1;

    return {
        id: caseNumber,
        title: `${caseNumber}. Dövme Silme Süreci Görseli`,
        image: `/images/before-after/case-${caseNumber}.jpeg`,
        description:
            "Dövme silme süreci kişiye, dövmenin rengine, yoğunluğuna, yaşına ve cilt yapısına göre değişebilir."
    };
});

const whatsappUrl =
    "https://wa.me/905359156506?text=Merhaba,%20d%C3%B6vme%20silme%20i%C3%A7in%20%C3%B6n%20de%C4%9Ferlendirme%20almak%20istiyorum.%20Foto%C4%9Fraf%20g%C3%B6nderebilirim.";

function CaseImage({ src, alt }) {
    return (
        <div className="relative overflow-hidden rounded-[1.6rem] border border-white/10 bg-black/50">
            <div className="absolute left-4 top-4 z-10 rounded-full border border-white/15 bg-black/65 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-white/90 backdrop-blur">
                Önce / Sonra
            </div>

            <img
                src={src}
                alt={alt}
                loading="lazy"
                className="max-h-[560px] w-full object-contain"
                onError={(event) => {
                    event.currentTarget.style.display = "none";
                    const fallback = event.currentTarget.nextElementSibling;
                    if (fallback) fallback.style.display = "flex";
                }}
            />

            <div className="hidden h-[420px] w-full items-center justify-center px-6 text-center text-sm text-zinc-400">
                Görsel eklenecek
            </div>
        </div>
    );
}

export default function BeforeAfterCarousel() {
    const carouselRef = useRef(null);

    const scrollCarousel = (direction) => {
        if (!carouselRef.current) return;

        const amount = carouselRef.current.clientWidth * 0.82;

        carouselRef.current.scrollBy({
            left: direction === "next" ? amount : -amount,
            behavior: "smooth"
        });
    };

    return (
        <section
            className="relative overflow-hidden border-b border-white/5 bg-[#070b12] py-20 md:py-28"
            data-testid="before-after-section"
        >
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(22,163,255,0.15),transparent_32%),radial-gradient(circle_at_85%_12%,rgba(33,230,255,0.09),transparent_30%)]" />

            <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="mb-10 flex flex-col gap-6 md:mb-14 md:flex-row md:items-end md:justify-between">
                    <div className="max-w-3xl">
                        <div className="mb-4 inline-flex rounded-full border border-cyan-400/20 bg-cyan-400/10 px-4 py-2 text-xs font-semibold uppercase tracking-[0.25em] text-cyan-200">
                            Önce / Sonra
                        </div>

                        <h2 className="text-3xl font-semibold tracking-tight text-white md:text-5xl">
                            Dövme Silme Sürecinden Gerçek Görseller
                        </h2>

                        <p className="mt-5 text-base leading-8 text-zinc-300 md:text-lg">
                            Dövmenin rengi, yoğunluğu, yaşı ve cilt yapısına göre süreç kişiden kişiye değişir.
                            Fotoğrafınızı göndererek size özel ön değerlendirme alabilirsiniz.
                        </p>
                    </div>

                    <div className="hidden items-center gap-3 md:flex">
                        <button
                            type="button"
                            onClick={() => scrollCarousel("prev")}
                            className="flex h-12 w-12 items-center justify-center rounded-full border border-white/10 bg-white/5 text-white transition hover:border-cyan-300/40 hover:bg-cyan-300/10"
                            aria-label="Önceki görsel"
                        >
                            ←
                        </button>

                        <button
                            type="button"
                            onClick={() => scrollCarousel("next")}
                            className="flex h-12 w-12 items-center justify-center rounded-full border border-white/10 bg-white/5 text-white transition hover:border-cyan-300/40 hover:bg-cyan-300/10"
                            aria-label="Sonraki görsel"
                        >
                            →
                        </button>
                    </div>
                </div>

                <div
                    ref={carouselRef}
                    className="-mx-4 flex snap-x snap-mandatory gap-6 overflow-x-auto px-4 pb-5"
                >
                    {beforeAfterCases.map((item) => (
                        <article
                            key={item.id}
                            className="min-w-[88%] snap-center rounded-[2rem] border border-white/10 bg-white/[0.045] p-4 shadow-2xl shadow-cyan-950/20 backdrop-blur md:min-w-[780px] md:p-5 lg:min-w-[920px]"
                        >
                            <CaseImage src={item.image} alt={item.title} />

                            <div className="mt-5 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
                                <div>
                                    <h3 className="text-lg font-semibold text-white md:text-xl">
                                        {item.title}
                                    </h3>
                                    <p className="mt-2 max-w-2xl text-sm leading-6 text-zinc-400">
                                        {item.description}
                                    </p>
                                </div>

                                <span className="inline-flex w-fit rounded-full border border-white/10 bg-black/30 px-3 py-1 text-xs font-medium text-cyan-100">
                                    Kişisel değerlendirme gerekir
                                </span>
                            </div>
                        </article>
                    ))}
                </div>

                <div className="mt-8 rounded-3xl border border-white/10 bg-black/25 p-5 md:flex md:items-center md:justify-between md:gap-8">
                    <p className="text-sm leading-7 text-zinc-300">
                        Görseller bilgilendirme amaçlıdır. Sonuçlar kişiden kişiye değişebilir.
                        Seans sayısı dövmenin rengine, yoğunluğuna, yaşına ve cilt yapısına göre farklılık gösterebilir.
                    </p>

                    <div className="mt-5 flex flex-col gap-3 sm:flex-row md:mt-0">
                        <a
                            href={whatsappUrl}
                            target="_blank"
                            rel="noreferrer"
                            className="inline-flex items-center justify-center rounded-full bg-cyan-300 px-5 py-3 text-sm font-bold text-slate-950 transition hover:bg-cyan-200"
                        >
                            Fotoğraf Gönder, Ön Değerlendirme Al
                        </a>

                        <a
                            href={whatsappUrl}
                            target="_blank"
                            rel="noreferrer"
                            className="inline-flex items-center justify-center rounded-full border border-white/15 px-5 py-3 text-sm font-semibold text-white transition hover:border-cyan-300/50 hover:bg-cyan-300/10"
                        >
                            WhatsApp’tan Bilgi Al
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}
